export {Account as Page};

import {Helmet} from "react-helmet-async";
import {useEffect, useState} from "preact/hooks";
import {Song} from "../../components/Song.jsx";
import {AccountSidebar} from "../../components/AccountSidebar.jsx";
import messages from "../../messages/messages.js";
import API_URL from "../../includes/api.js";
import {useAuth} from '../../components/AuthProvider.jsx';
import {RingSpinner} from "../../components/Spinner.jsx";

function Account() {

    const {getToken, user, authLoading} = useAuth();

    const [favorites, setFavorites] = useState([]);
    const [memberSongs, setMemberSongs] = useState([]);
    const [favoritesLoading, setFavoritesLoading] = useState(true);
    const [memberSongLoading, setMemberSongsLoading] = useState(true);

    useEffect(() => {
        if (authLoading) return;

        if (!user) return;

        getToken().then(token => {
            fetch(API_URL + "/favorite/getall?firebase_auth_token=" + token)
                .then(response => response.json()).then(data => {
                if (data.code === 200) {
                    setFavorites(data.data);
                }
            }).finally(() => {
                setFavoritesLoading(false);
            });

            fetch(API_URL + "/account/get_member_songs?firebase_auth_token=" + token)
                .then(response => response.json()).then(data => {
                if (data.code === 200) {
                    setMemberSongs(data.data);
                }
            }).finally(() => {
                setMemberSongsLoading(false);
            });
        });
    }, [authLoading, user])

    return (
        <section className="text-white">

            <Helmet>
                <title>{messages["SITE.NAME"]} | My account</title>
                <meta name="description" content="Check out your favorite songs and awesome benefits as a subscriber!"/>
            </Helmet>

            <div>
                <div className="flex flex-wrap">

                    <AccountSidebar/>

                    <div className="w-full md:w-3/4 px-0 md:px-4">
                        <div className="border border-border/60 bg-zinc-800 rounded-lg p-6 mb-4">
                            <h3 className="text-xl mt-0 mb-2">Welcome to your account page!</h3>
                            <p className="m-0 text-sm text-gray-400"> From here, you can access all of your favorite
                                tracks and manage your personal information. You can also take advantage of exclusive
                                benefits available only to subscribers.</p>
                        </div>

                        <div className="border border-border/60 bg-zinc-800 rounded-lg p-6 mb-4">
                            <h3 className="text-xl m-0 pb-2">Favorites</h3>
                            <div className="max-h-105 overflow-y-auto">
                                {favoritesLoading ? (
                                    <div className="text-center">
                                        <div role="status">
                                            <RingSpinner className="inline w-8 h-8 mr-2 animate-spin text-gray-600 fill-red-400" trackFill="currentColor"/>
                                        </div>
                                        <h2 className="text-2xl font-bold">Loading...</h2>
                                    </div>
                                ) : (
                                    favorites.length === 0 ? (
                                        <p className="mt-2 mb-0">There are no songs in your favorites.</p>
                                    ) : (
                                        <div className="grid grid-cols-1 md:grid-cols-2 gap-6 mr-4">
                                            {favorites.map((song) => (
                                                <Song song={song} hideHr={true}/>
                                            ))}
                                        </div>
                                    )
                                )}
                            </div>
                        </div>

                        <div className="border border-border/60 bg-zinc-800 rounded-lg p-6 mb-4">
                            <h3 className="text-xl m-0 pb-2">My Songs</h3>
                            <div className="max-h-105 overflow-y-auto">
                                {memberSongLoading ? (
                                    <div className="text-center">
                                        <div role="status">
                                            <RingSpinner className="inline w-8 h-8 mr-2 animate-spin text-gray-600 fill-red-400" trackFill="currentColor"/>
                                        </div>
                                        <h2 className="text-2xl font-bold">Loading...</h2>
                                    </div>
                                ) : (
                                    memberSongs.length === 0 ? (
                                        <p className="mt-2 mb-0">There are no songs associated with your account.</p>
                                    ) : (
                                        <div className="grid grid-cols-1 md:grid-cols-2 gap-6 mr-4">
                                            {memberSongs.map((song) => (
                                                <Song song={song} hideHr={true}/>
                                            ))}
                                        </div>
                                    )
                                )}
                            </div>
                        </div>
                    </div>
                </div>

            </div>
        </section>
    );
}
